function alertModelMsg(msg,fun,num){
  num=parseInt(isNaN(num)?0:num);

  var d=document.createElement("div");
  d.style="position:fixed;top:0;left:0;right:0;bottom:0;z-index:9000;";
  d.innerHTML="<p style='z-index:19999;box-sizing:border-box;position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,0%);-moz-transform:translate(-50%,0%);-ms-transform:translate(-50%,0%);transform:translate(-50%,0%);width:62%;line-height:25px;font-size:16px;color: #fff;text-align: center;padding: 5px 10px;background-color: rgba(0,0,0,0.6);border-radius:5px;'>"+msg+"</p>";

  document.body.append(d);

  setTimeout(function(){

    d.parentNode.removeChild(d);
    if(typeof(fun)=="function"){
      fun();
    }

  },num>0?num:1200);

}


export {
  alertModelMsg
}

